<template>
  <div >
    <div  class="spacing"></div>
    <b-row :class="[style]" class="fixed-bottom">
      <b-col>
        <slot name="button"></slot>
      </b-col>
    </b-row>

  </div>
</template>

<script>
    export default {
        name: "luma-button-wrapper",
        data:()=>({
            window: {
                width: 0,
                height: 0
            }
        }),
        computed:{
            style(){
                return this.window.width <= 768 ? 'footer-summary-mobile' : 'footer-summary'
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods: {
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            }
        }
    }
</script>

<style scoped>
  .spacing{
    height: 300px;
  }
  .footer-summary {

    margin-left: 220px;
    z-index: 1000;
    padding: 20px;
    bottom: 0px;
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }
  .footer-summary-mobile {
    z-index: 1000;
    padding: 20px;
    bottom: 0px;
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/luma-button-wrapper.vue